import { render, staticRenderFns } from "./TheRecipeMenu.vue?vue&type=template&id=25b82107&"
import script from "./TheRecipeMenu.vue?vue&type=script&lang=js&"
export * from "./TheRecipeMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports